<template>
	<page enable-flex>
		<view-list ref="view" work-type="22" :search="{scan: true}">
			<template #filter>
				<m-search>
					<m-search-item label="关联采购单">
						<c-input name="purchase_code"></c-input>
					</m-search-item>
					<m-search-item label="采购员">
						<c-input name="purchase_user_name"></c-input>
					</m-search-item>
					<m-search-item label="等级">
						<c-checkbox-group name="level_types" :options="LEVEL_TYPE"></c-checkbox-group>
					</m-search-item>
					<m-search-item label="入库时间">
						<c-datetime range start-name="stock_in_start_date" end-name="stock_in_end_date"></c-datetime>
					</m-search-item>
					<m-search-item label="库龄范围">
						<div class="flex-center">
							<c-input class="flex-grow" type="number" name="stock_days_min" placeholder="最小值" append-text="天"></c-input>
							<span style="margin: 0 .5em;">-</span>
							<c-input class="flex-grow" type="number" name="stock_days_max" placeholder="最大值" append-text="天"></c-input>
						</div>
					</m-search-item>
				</m-search>
			</template>

			<template #handle>
				<topbar-handle type="model" label="机型" name="spu_model_id"></topbar-handle>
				<topbar-handle type="sort" label="库龄" name="stock_days"></topbar-handle>
			</template>

			<template #head={data}>
				<div class="total-bar flex-between-center">
					<span>数量：{{fieldValid(data.total_count)}}</span>
					<span>总成本：￥{{fieldValid(data.cost_money)}}</span>
					<span>台均成本：￥{{fieldValid(data.avg_cost_money)}}</span>
				</div>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #tag>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #name>
						{{[data.brand_name, data.spu_model_name, data.memory_name, data.color_name].filter(item => item).join(' ') || '-'}}
					</template>

					<template #state>
						<span v-if="isSourceRejectPending(data)" style="color: #e53e3e;">被驳回中</span>
					</template>

					<template #total>
						<view-list-total name="在库天数" :value="data.stock_days"></view-list-total>
					</template>

					<template #default>
						<c-field label="背贴码">{{data.produce_unique_code}}</c-field>
						<c-field label="IMEI">{{data.produce_imei}}</c-field>
						<c-field label="状态"><c-state dict="UNIQUE_CODE_STATE" :value="data.state"></c-state></c-field>
						<c-field label="采购价">
							<span style="color: #FF6900;">￥{{data.purchase_price}}</span>
							<label>维修价：</label>
							<span style="color: #FF6900;">￥{{data.repair_cost}}</span>
						</c-field>
					</template>
					<template #operate>
						<c-button v-if="data.buttons?.confirm_reject?.visible && auth('b_app_stock_balance_confirm_reject')" color="main" hollow @click="confirmReject(data)">同意驳回</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	import handoverReject from '@/mixins/handover_reject'
	import {asyncMapState} from '@/store'

	export default {
		mixins: [handoverReject],

		handoverModuleType: 0,

		data() {
			return {
			}
		},

		computed: {
			...asyncMapState(['LEVEL_TYPE'])
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
</style>